import {
  Box,
  Divider,
  Grid,
  List,
  ListItem,
  Stack,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
// import CopyRight from "./CopyRight";
import { t } from "i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appImages } from "../../assets";
import CopyRight from "./CopyRight";

const FooterView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.gradient.footer,
  maxWidth: "1100px",
  margin: "auto",
  padding: "16px",
  display: "flex",
  alignItems: "flex-start",
  [theme.breakpoints.down("sm")]: {
    alignItems: "center",
    flexDirection: "column",
  },
}));

let product = [
  {
    title: "aboutUs",
    link: "/about-us",
  },
  {
    title: "contactUs",
    link: "/contact-us",
  },
  {
    title: "pricing",
    link: "/pricing",
  },
  {
    title: "helpDesk",
    link: "/help-center",
  },
  {
    title: "blogs",
    link: "/blogs",
  },
];

let solution = [
  {
    title: "eazistores",
    link: "/",
  },
  {
    title: "cleaningServices",
    link: "/cleaning-services",
  },
  // {
  //   title: "Car Services",
  //   link: "/car-services",
  // },
];

let resources = [
  {
    title: "privacyPolicy",
    link: "/privacy-policy",
  },
  {
    title: "termsAndConditions",
    link: "/terms-conditions",
  },
  // {
  //   title: "disputeResolution",
  //   link: "/consumer-protection",
  // },
  {
    title: "cookiePolicy",
    link: "/cookie-policy",
  },
  // {
  //   title: "insurancePolicy",
  //   link: "/insurance-policy",
  // },
  {
    title: "workerGuidancePolicy",
    link: "/worker-guidance-policy",
  },
  // {
  //   title: "Return Policy",
  //   link: "/return-policy",
  // },
];

function AppFooter({ bgcolor }) {
  const { palette } = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    if (route == "/consumer-protection") {
      return window.open(
        "https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=EN",
        "_blank"
      );
    }
    navigate(route);
  };

  const renderFooterItems = (title, data) => {
    return (
      <Stack flex={1}>
        <Typography
          fontSize={"18px"}
          fontWeight={"bold"}
          color={bgcolor ? "text.white" : "text.black"}
          textTransform={"capitalize"}
        >
          {t(title)}
        </Typography>
        <List sx={{ mt: 1 }}>
          {data?.map((val, ind) => {
            return (
              <ListItem key={ind} sx={{ px: 0, pb: 0, cursor: "pointer" }}>
                <Stack
                  style={{
                    color: bgcolor ? "white" : "#161c2d",
                    textTransform: "capitalize",
                  }}
                  className="footer-links"
                  onClick={() => handleNavigation(val?.link)}
                  // component={val?.link ? "a" : "button"}
                  // href={val?.link ? val?.link : null}
                  // target={val?.link ? "_blank" : null}
                >
                  {t(val.title)}
                </Stack>
              </ListItem>
            );
          })}
        </List>
      </Stack>
    );
  };

  const renderDownloadBtn = (title, data) => {
    return (
      <Stack flex={1}>
        <Typography
          fontSize={"18px"}
          fontWeight={"bold"}
          color={bgcolor ? "text.white" : "text.black"}
          textTransform={"capitalize"}
        >
          {t(title)}
        </Typography>
        <Stack spacing={1} mt={4}>
          <a
            onClick={() => navigate("/coming-soon")}
            style={{ cursor: "pointer" }}
          >
            <img src={appImages.appStoreImg} width={120} />
          </a>
          <a
            onClick={() => navigate("/coming-soon")}
            style={{ cursor: "pointer" }}
          >
            <img src={appImages.playStoreImg} width={120} />
          </a>
          <a
            href="https://anpc.ro/ce-este-sal/"
            target="_blank"
            style={{ cursor: "pointer" }}
          >
            <Box
              component={"img"}
              src={appImages.anpcImage}
              width={{ xs: "100%", sm: 250 }}
            />
          </a>
          <a
            href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO%3E"
            target="_blank"
            style={{ cursor: "pointer" }}
          >
            <Box
              component={"img"}
              src={appImages.litigiuImage}
              width={{ xs: "100%", sm: 250 }}
            />
          </a>
        </Stack>
      </Stack>
    );
  };

  return (
    <Box
      sx={{
        background: bgcolor ? palette.gradient.footer : "text.white",
        padding: { xs: 1, sm: "40px 0px 0px 0px" },
        mt: 6,
      }}
    >
      <FooterView>
        <Grid container mt={{ xs: 3, sm: 0 }}>
          <Grid item xs={6} sm={4} md={3}>
            {renderFooterItems("company", product)}
          </Grid>
          <Grid item xs={6} sm={4} md={3}>
            {renderFooterItems("product", solution)}
          </Grid>
          <Grid item xs={6} sm={4} md={3}>
            {renderFooterItems("legal", resources)}
          </Grid>
          <Grid item xs={6} sm={4} md={3}>
            {renderDownloadBtn("downloadOurApp")}
          </Grid>
        </Grid>
      </FooterView>
      <Divider
        sx={{
          my: 1,
        }}
      />
      <CopyRight bgcolor={bgcolor} />
    </Box>
  );
}

export default AppFooter;
